import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ZapIcon, ShoppingBasketIcon } from 'lucide-react';
import { Button } from '../ui/Button';
import { HERO_MOCKUP } from '../../data/content';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function Hero() {
  return <section className="relative pt-24 pb-12 md:pt-28 md:pb-16 overflow-hidden" data-id="element-115" data-mp="qu2qoyiraj9d">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[500px] bg-pistachio-200/50 rounded-full blur-[120px] pointer-events-none" data-id="element-116" data-mp="vndns7xrnlo3" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-117" data-mp="10n9sk9eafh4p">
        <motion.div className="max-w-4xl mx-auto text-center" variants={containerVariants} initial="hidden" animate="visible" data-id="element-118" data-mp="15m3807d4xi7i">
          <motion.div variants={itemVariants} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-surface border border-line text-sm font-medium text-pistachio-800 mb-5" data-id="element-119" data-mp="9o2odh56giky">
            <span aria-hidden="true" data-id="element-120" data-mp="3vvj4o5sntkpj">🌿</span> CLOSE THE GAP™
          </motion.div>

          <motion.h1 variants={itemVariants} className="font-display font-bold text-ink mb-1 text-balance text-4xl sm:text-5xl md:text-6xl" data-id="element-121" data-mp="3ruh3hjf6mykx">
            Tu semana de comida. Resuelta. Desde hoy.
          </motion.h1>

          <motion.div variants={itemVariants} className="mb-2" data-id="element-122" data-mp="iohectt36lus">
            <div className="relative mx-auto w-full max-w-2xl md:max-w-3xl" data-id="element-123" data-mp="imxy337fkat0">
              <img src={HERO_MOCKUP} alt="Mega Pack Cocina Lista — 6 Tomos, 6 Bonos y el Método Cocina Impecable de Close The Gap" className="relative w-full h-auto max-h-[62vh] object-contain mx-auto drop-shadow-xl" loading="eager" data-id="element-124" data-mp="elukkncuuquy" />
            </div>
          </motion.div>

          <motion.p variants={itemVariants} className="text-lg md:text-xl text-muted mb-6 max-w-3xl mx-auto text-balance" data-id="element-125" data-mp="35l0le26h0v8d">
            El sistema completo de batch cooking para argentinos que quieren comer bien,
            gastar menos y recuperar sus domingos de una vez por todas.
          </motion.p>

          <motion.div variants={itemVariants} className="flex flex-wrap justify-center gap-3 mb-8" data-id="element-126" data-mp="2huec67kqd4ws">
            <Badge icon={<FileTextIcon size={16} data-id="element-128" data-mp="2ms64h2paet1i" />} text="100% PDF" data-id="element-127" data-mp="2mvtw1wb695dl" />
            <Badge icon={<ZapIcon size={16} data-id="element-130" data-mp="27yt6nzggdmia" />} text="Acceso en 5 min" data-id="element-129" data-mp="27yjpn1ddypoq" />
            <Badge icon={<ShoppingBasketIcon size={16} data-id="element-132" data-mp="2cx4e63j9zkxc" />} text="Ingredientes de súper o feria" data-id="element-131" data-mp="2cvtcqadayp9e" />
          </motion.div>

          <motion.div variants={itemVariants} className="flex flex-col items-center gap-4" data-id="element-133" data-mp="63sh70r0q2jn">
            <Button size="xl" href="#pricing" className="w-full sm:w-auto px-12" data-id="element-134" data-mp="b2vpcu2aoovu">
              <span aria-hidden="true" className="mr-2" data-id="element-135" data-mp="1vnjzajbft4za">
                🛒
              </span>{' '}
              → QUIERO MI MEGA PACK AHORA
            </Button>
            <p className="text-xs text-muted flex flex-wrap justify-center items-center gap-2" data-id="element-136" data-mp="25d3kvwqjbcxu">
              <span aria-hidden="true" data-id="element-137" data-mp="20llmngfwbqgk">🛡️</span> Garantía 7 días{' '}
              <span className="text-pistachio-300" data-id="element-138" data-mp="20kaivgmgaipg">·</span>{' '}
              <span aria-hidden="true" data-id="element-139" data-mp="2ebxerfchdp7p">🔒</span> Pago seguro{' '}
              <span className="text-pistachio-300" data-id="element-140" data-mp="2acok889m9nb3">·</span>{' '}
              <span aria-hidden="true" data-id="element-141" data-mp="2ae9d7tga8y6u">💳</span> Mercado Pago
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}
function Badge({
  icon,
  text
}: {
  icon: React.ReactNode;
  text: string;
}) {
  return <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-surface border border-line text-xs font-medium text-pistachio-800" data-id="element-142" data-mp="twvefk7zfhgw">
      <span className="text-pistachio-600" aria-hidden="true" data-id="element-143" data-mp="p0er2s8lx74v">
        {icon}
      </span>
      <span data-id="element-144" data-mp="qf7ojv6imvb0">{text}</span>
    </div>;
}